import { Input, ToastMessage, Textarea, Breadcrumbs } from '@cokitchen/cokitchen-components';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import PageHeaderText from 'components/base/page-header-text';
import { AppFormDataType } from './types';
import SingleBottomNav from 'components/base/single-bottom-nav';

type InputType = {
  name: string;
  label: string;
  placeholder: string;
  value: string;
};
const AppSettings = () => {
  const [formData, setFormData] = useState({} as AppFormDataType);
  const [loading, setLoading] = useState(false);
  const breadCrumbs = [
    { name: 'Settings', path: `/settings` },
    {
      name: 'App version',
      path: ''
    }
  ];

  const APP_FORM_INPUT: InputType[] = [
    {
      name: 'android',
      label: 'Android version',
      placeholder: '2.1.20',
      value: formData?.android
    },
    {
      name: 'ios',
      label: 'Ios version',
      placeholder: '2.1.20',
      value: formData?.ios
    },
    {
      name: 'header',
      label: 'Header (Update title)',
      placeholder: 'New App Update',
      value: formData?.header
    },
    {
      name: 'whats_new',
      label: "What's new",
      placeholder: "What's new in this update",
      value: formData?.whats_new
    },
    {
      name: 'button_link',
      label: 'Button link',
      placeholder: 'Paste link',
      value: formData?.button_link
    },
    {
      name: 'button_text',
      label: 'Button text',
      placeholder: 'Update App',
      value: formData?.button_text
    }
  ];
  const navigate = useNavigate();

  const handleInputChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const updateDetails = async () => {
    setLoading(true);
    try {
      const res = await apiService.post('marketing/versions', { data: formData });
      if (res?.data) {
        toast(<ToastMessage type='success' message='App version updated successfully' />);
        fetchData();
      }
      navigate(-1);
    } catch {
      toast(<ToastMessage type='error' message='Error encountered while updating app version' />);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiService.get('internal/versions', {
        isInternal: true
      });
      const response: AppFormDataType = res?.data?.data;
      // eslint-disable-next-line
      const { id, status, message, created_at, updated_at, ...rest } = response;
      if (response) setFormData(rest);
    } catch {
      toast(<ToastMessage type='error' message='Error encounterd while updateing app version' />);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className='max-w-[755px]'>
      <Breadcrumbs breadcrumbs={breadCrumbs} />
      <PageHeaderText title='App version' description='Update the FoodCourt app version' />
      <div className='space-y-5 pb-8'>
        {APP_FORM_INPUT.map((input, index) => (
          <Input
            disabled={loading}
            key={index}
            type='text'
            name={input?.name}
            onChange={handleInputChange}
            label={input?.label}
            value={input?.value}
            placeholder={input?.placeholder}
            small
          />
        ))}

        <Input
          disabled={loading}
          type='checkbox'
          name='skip_bool'
          checked={formData?.skip_bool}
          checkColor='gray'
          onChange={() => setFormData({ ...formData, skip_bool: !formData?.skip_bool })}
          label='Skip ?'
          labelDirection='left'
          small
          className='py-3'
        />

        {formData?.skip_bool && (
          <Input
            disabled={loading}
            value={formData?.skip_text}
            name='skip_text'
            onChange={handleInputChange}
            label='Skip Text'
            placeholder='Ask me later'
            small
          />
        )}
        <Textarea
          disabled={loading}
          name='message'
          value={formData?.text}
          onChange={handleInputChange}
          label='Description'
          className='h-40 '
          placeholder='Update your app for the latest fixes & improvements!'
        />
      </div>
      <SingleBottomNav loading={loading} onConfirm={updateDetails} buttonText='Update Version' />
    </div>
  );
};

export default AppSettings;
